import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import Header from "../components/layout/Header";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet-async";
const LocalhostIframe = () => {
  const jwtToken = Cookies.get("access_token");
  // console.log("JWT Token from cookies:", jwtToken);
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        {/* <IonHeader mode="ios">
          <Header />
        </IonHeader> */}
        <IonContent>
          <div
            style={{
              width: "100%",
              height: "100vh",
              // height: "calc(100svh - 135px)",
              position: "relative",
            }}
          >
            <iframe
              src={`https://travel.loonlog.ca?sso=${jwtToken}`}
              // src={`http://localhost:5173?sso=${jwtToken}`}
              allow="geolocation"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              title="Ride"
            />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default LocalhostIframe;
